import { StepPopupActions } from './../../_models/steps';
import { CustomStepCategoryEnum, OfferIntents, OfferTypes } from '../../_models/funnel';
import { BaseModel } from '../../_models/base-model';

export interface Step extends BaseModel {
  category: CustomStepCategoryEnum;
  display_id: number;
}

export interface SurveyStep extends BaseModel {
  display_id: number;
  is_modified: boolean;
  last_modified: string;
  created: string;
  name: string;
  category: CustomStepCategoryEnum;
  offer_intent: OfferIntents;
  offer_type: OfferTypes;
  is_public: boolean;
  paths: BaseModel[];
  steps: Step[];
  sessions?: number;
  cancels?: number;
  saves?: number;
  segments?: string[] | number[];
  stage: string | null;
  previewLoading?: boolean;
  showThreeDotMenu?: boolean;
  funnel?: number | string;
  isPublishing?: boolean;
  isPublishable?: boolean;
  firstStep: Step;
}

export interface PopupData {
  name: string;
  is_survey: boolean;
  offer_id: number | string | null;
  step_id: number | string | null;
  offer_intent: OfferIntents | null;
  offer_type: OfferTypes | null;
  popupType: StepPopupActions | null;
}

export const SurveyPopupTitleMap = {
  [StepPopupActions.Update]: 'Rename Survey',
  [StepPopupActions.Duplicate]: 'Duplicate Survey',
  [StepPopupActions.Delete]: 'Delete Survey',
};
